import { render } from "./SocialMedia.vue?vue&type=template&id=536874f0&scoped=true"
import script from "./SocialMedia.vue?vue&type=script&lang=js"
export * from "./SocialMedia.vue?vue&type=script&lang=js"

import "./SocialMedia.vue?vue&type=style&index=0&id=536874f0&scoped=true&lang=css"
import "./SocialMedia.vue?vue&type=style&index=1&id=536874f0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-536874f0"]])

export default __exports__